import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from 'library-@/config/constants';
import type {
    CheckPatentWithReasoningParams,
    ReasoningApi,
    ReasoningQueryParams,
    ReasoningQueryResult,
} from './reasoning-api.interface';

export class ReasoningApiImpl implements ReasoningApi {
    getReasoning(params: ReasoningQueryParams): Promise<ReasoningQueryResult> {
        const { folder_id, field_id, patent_id, signal } = params;
        return psHttp({
            url: `${workspaceApiUrlPrefix}/smart/folder/${folder_id}/field/${field_id}/reasoning`,
            method: 'GET',
            params: { patent_id },
            transformCode: true,
            signal,
        }).then(({ data }) => data.data as ReasoningQueryResult);
    }

    checkPatentWithReasoning(params: CheckPatentWithReasoningParams): Promise<boolean> {
        const { folder_id, field_id, patent_id, save_reasoning_as_comment, comment_visible_scope } = params;
        return psHttp({
            url: `${workspaceApiUrlPrefix}/smart/folder/${folder_id}/field/${field_id}/check-patent`,
            method: 'POST',
            data: {
                patent_ids: [patent_id],
                refiner: {},
                select_mode: 'INCLUDE',
                save_reasoning_as_comment,
                comment_visible_scope,
            },
            transformCode: true,
        }).then(({ data }) => data.data as boolean);
    }
}
